import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "frontend-debugger"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "frontend-debugger__toggle button button--primary button--medium button--round" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "button__wrap" }, "Toggle Story")
], -1)
const _hoisted_3 = { class: "frontend-debugger__info" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "checkbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown = _resolveComponent("dropdown")!

  return (_openBlock(), _createBlock(_Transition, { name: "trs-simple-fade" }, {
    default: _withCtx(() => [
      (_ctx.story)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_dropdown, null, {
              trigger: _withCtx(() => [
                _hoisted_2
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "frontend-debugger__description",
                    innerHTML: _ctx.story.description
                  }, null, 8, _hoisted_4),
                  _createElementVNode("label", _hoisted_5, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showIDS && _ctx.showIDS(...args)))
                    }, null, 32),
                    _createTextVNode(" Toggle Element IDS ")
                  ])
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}